/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
import React, { useContext } from 'react';
import PropType from 'prop-types';
import clsx from 'clsx';
import { cloneDeep } from 'lodash';
import { AppContext } from '../../context/AppContext';
import NSearchableDropDown from '../inputs/NSearchableDropdown';

function WidgetDropdown(props) {
  const { scope, isSelected, widgetIndex } = props;
  const {
    widgetDropDownOptions: dropDownOptions,
    widgetSettings,
    setWidgetSettings,
  } = useContext(AppContext);

  const getCustomerDropDownOptions = () =>
    dropDownOptions?.map((o) => ({
      label: o?.customerName,
      value: o?.customerID?.toString(),
    })) || [];

  const getProjectDropDownOptions = () =>
    dropDownOptions
      ?.find((f) => f.customerID === getDropDownValue()?.customerId)
      ?.projects?.map((o) => ({
        label: o?.name,
        value: o?.id?.toString(),
      })) || [];

  const getDropDownValue = () => {
    if (!widgetSettings) return undefined;
    if (isSelected) {
      return widgetSettings.selected[widgetIndex];
    }
    return widgetSettings.unSelected[widgetIndex];
  };

  const handleChangeDropDownOptions = (type, _customerId, _projectId) => {
    const _widgetSettings = cloneDeep(widgetSettings);
    if (!_widgetSettings) return;

    const widgetType = isSelected ? 'selected' : 'unSelected';
    if (type === 'customer') {
      _widgetSettings[widgetType][widgetIndex].customerId = _customerId;
      _widgetSettings[widgetType][widgetIndex].projectId = '';
    } else if (type === 'project') {
      _widgetSettings[widgetType][widgetIndex].projectId = _projectId;
    }

    setWidgetSettings(_widgetSettings);
  };

  const optionValueCustomer = (val) => {
    const selectedObj = dropDownOptions?.find((o) => o?.customerID?.toString() === val?.toString());
    return { label: selectedObj?.customerName, value: selectedObj?.customerID?.toString() };
  };

  const optionValueProject = (projVal) => {
    const selectedObj = dropDownOptions
      ?.find((f) => f.customerID === getDropDownValue()?.customerId)
      ?.projects?.find((o) => o?.id?.toString() === projVal?.toString());
    return { label: selectedObj?.name, value: selectedObj?.id?.toString() };
  };

  if (!scope) return null;
  return (
    <div className='widget-dropdown'>
      <div
        className={clsx(
          { selected: isSelected },
          { notSelected: !isSelected },
          'flex items-center justify-between gap-4',
        )}
      >
        {!isSelected && (
          <div className='w-full'>
            <p className='mb-2 text-[10px] text-gray-900 break:mb-2.5 break:text-sm'>
              Choose the customer
            </p>
            <NSearchableDropDown
              label='Select Customer'
              options={getCustomerDropDownOptions()}
              onChange={(e, selected) => {
                handleChangeDropDownOptions('customer', selected?.value);
              }}
              value={optionValueCustomer(getDropDownValue()?.customerId)}
            />
          </div>
        )}
        <div className='w-full'>
          {!isSelected && (
            <p className='mb-2 text-[10px] text-gray-900 break:mb-2.5 break:text-sm'>
              Choose the project
            </p>
          )}
          <NSearchableDropDown
            label='Select Project'
            options={getProjectDropDownOptions()}
            onChange={(e, selected) => {
              handleChangeDropDownOptions('project', null, selected?.value);
            }}
            value={optionValueProject(getDropDownValue()?.projectId)}
          />
        </div>
      </div>
    </div>
  );
}

WidgetDropdown.propTypes = {
  scope: PropType.oneOfType([
    'MonthInvoiceDetails',
    'TodayDeliveredSchedule',
    'TonnageConsumptions',
    'ContractConsumptions',
    'RecentInvoiceDetails',
  ]),
  isSelected: PropType.bool,
  widgetIndex: PropType.number,
};

WidgetDropdown.defaultProps = {
  scope: undefined,
  isSelected: false,
  widgetIndex: undefined,
};

export default WidgetDropdown;
